import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const deleteTheme = (id: number): AxiosPromise =>
  instance.delete(`/api/themes/${id}`);

export default deleteTheme;
